<template>
  <span>
    <div class="background-wallpaper" style="background-image: url(https://res.cloudinary.com/hyimvofxm/image/upload/v1636737932/9_68caa27a4e.png);"></div>

    <FormulateForm
      class="spaced contactform n"
      style="margin-top: 150px"
      @submit="submitForm"
    >
      <div class="container content">
        <div class="column c12 text-center">
          <h1>GET IN TOUCH</h1>
        </div>
        <div class="column c8 push-center" style="padding: 20px">
          <p class="text-center">
            We at patronus would love to hear what you have to share, Where its
            general feedback, or other partnership inquiries feel free to get in
            touch at anytime using the form below.
          </p>
          <div class="form">
            <div class="form-item form-section">
              <div class="label">Full name</div>
              <FormulateInput
                type="text"
                name="fullname"
                validation="required"
                class="form-100"
                v-model="form.Fullname"
              />
            </div>
            <div class="form-item form-section">
              <div class="label">Email address</div>
              <FormulateInput
                type="email"
                name="Email"
                validation="required"
                class="form-100"
                v-model="form.Email"
              />
            </div>
            <div class="form-item form-section">
              <div class="label">Subject</div>
              <FormulateInput
                type="select"
                name="Subject"
                validation="required"
                class="form-100"
                :options="[
                  'Bookings',
                  'Events',
                  'Purchases',
                  'General Inquiries',
                ]"
                v-model="form.Subject"
              />
            </div>
            <div class="form-item form-section">
              <div class="label">Share your thoughts</div>
              <FormulateInput
                type="textarea"
                name="Message"
                validation="required"
                class="form-100"
                v-model="form.Message"
              />
            </div>
            <div class="form-item">
              <input class="submit" type="submit" :disabled='isDisabled'>
            </div>
          </div>
        </div>
      </div>
    </FormulateForm>
  </span>
</template>

<script>
import axios from 'axios'
import emailjs from 'emailjs-com'

export default {
  title: 'Patronus Records - Contact',
  name: 'home',
  data () {
    return {
      isDisabled: false,
      form: {
        Fullname: null,
        Email: null,
        Subject: [],
        Message: null
      },
      body: null
    }
  },
  methods: {
    submitForm () {
      this.isDisabled = true
      axios
        .post('https://admin.patronusrecords.com/contacts', this.form)
        .then((res) => {
          console.log('success')
          emailjs
            .send(
              'service_omqin1f',
              'template_p0x6bz5',
              {
                from_name: this.form.Fullname,
                email: this.form.email,
                type: 'Contact',
                message: this.form.Subject + '\n\n' + this.form.Message
              },
              'user_rDkovUZ6FIPW5500KTKAa'
            )
            .then(
              (result) => {
                console.log('SUCCESS!', result.text)
                this.$router.push('thankyou')
              },
              (error) => {
                console.log('FAILED...', error.text)
              }
            )
        })
        .catch((error) => {
          console.log('failed', error)
        })
    }
  }
}
</script>

<style>
.contactform .banner {
  width: 100vw;
  /* height: 420px; */
  padding-bottom: 500px;
  display: inline-block;
  vertical-align: top;
  position: relative;
  overflow: hidden;
  background-position: top center;
  background-size: cover;
}
.contactform .label {
  clear: both;
  display: block;
  width: 100%;
  text-transform: uppercase;
  padding-top: 20px;
  padding-bottom: 5px;
}
.contactform input,
.contactform textarea,
.contactform select {
  padding: 15px;
  background-color: #080c1780;
  border: none;
  width: 100%;
  max-width: 500px;
  color: white;
  border-radius: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: 100;
}
.contactform button {
  width: 100%;
  max-width: 300px;
  cursor: pointer;
}
.form-section .formulate-input-label {
  clear: both;
  display: block;
  width: 100%;
  text-transform: uppercase;
  padding-top: 20px;
  margin-bottom: 10px;
}
.form-section input,
.form-section textarea,
.form-section select {
  padding: 15px;
  background-color: #080c1780;
  border: none;
  width: 100%;
  color: white;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 100;
}
.form-section button {
  width: 100%;
  max-width: 300px;
  cursor: pointer;
}
.form-section .formulate-input-error {
  color: red;
  padding: 10px;
}
.form-50 {
  width: 50%;
  padding: 10px;
  float: left;
}
.form-100 {
  width: 100%;
  padding: 10px;
  float: left;
}
h2.FormTitle {
  background-color: var(--primary);
  padding: 15px;
  border-radius: 11px;
  text-align: left;
  padding-left: 30px;
  clear: both;
  margin-top: 20px;
}
h3.FormTitle {
  padding: 15px;
  border-radius: 11px;
  text-align: left;
  clear: both;
  margin-left: -10px;
  margin-top: 20px;
}
.form-section {
  clear: both;
  margin-top: 20px;
  margin-bottom: 10px;
  overflow: auto;
}

.optionbox input ~ label {
  border: 1px solid var(--secondary);
  display: block;
  width: 20px;
  height: 20px;
  float: left;
  border-radius: 100%;
}
.optionbox input:checked ~ label {
  border: 1px solid green;
  display: block;
}

.optionbox [type="checkbox"],
[type="radio"] {
  display: none;
}
.optionbox .formulate-input-group-item {
  width: 25%;
  padding: 4px;
  float: left;
}
.optionbox .formulate-input-label {
  text-align: left;
  float: left;
  margin-left: 8px;
}
.optionbox input:checked ~ label::after {
  content: " ";
  display: block;
  position: relative;
  background-color: green;
  border-radius: 10px;
  height: 10px;
  width: 10px;
  margin-left: 4px;
  margin-top: 4px;
}
@media only screen and (max-width: 660px) {
  .form-50 {
    width: 100%;
  }
  .form-50 button {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/contact.vue